import { useCallback, useContext, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getLayerSymbology } from "../../../../../utils/symbologies";
import { FilterIcon } from "../../../../Icons";
import { Checkbox, FilterButton, Tooltip } from "../../../../UI";
import { StyledReportFilterContainer } from "../../Editor-styled";
import { EditorContext } from "../../EditorContextProvider";

const ReportsFilter = ({
  config,
  t,
  filters,
  setAndApplyFilters,
  layerReports,
  showFeaturesWithoutUpdates,
  setShowFeaturesWithoutUpdates,
  showSuggestUpdates,
  setShowSuggestUpdates,
}) => {
  const [show, setShow] = useState(false);
  const activeModule = useSelector((state) => state.activeModule);
  const view = useSelector((state) => state.mapViewReducer.view);
  const reports = useSelector((state) => state.dashboard.reports);
  const cachedReportFilters = useRef([]);

  const { editableLayer } = useContext(EditorContext);

  const validationStatusMap = useMemo(() => {
    let features = [];
    if (editableLayer.layerConfig.isShownInReportManager) {
      features = reports.filter((f) => f.attributes.reporttype === 1);
    } else {
      features = layerReports;
    }

    const statusMap = {};

    features.forEach((feature) => {
      const status = feature.attributes.currvalidationfield;
      if (!statusMap[status]) {
        statusMap[status] = 0;
      }
      statusMap[status]++;
    });

    return statusMap;
  }, [reports, editableLayer, layerReports]);

  const colors = useMemo(() => {
    const layer = view.map.layers.find(
      (l) => l.visible && l.layerConfig?.isShownInReportManager
    );

    if (!layer) return [];
    const { colorMap = {} } = getLayerSymbology(layer, config) || {};
    if (!colorMap.default) return [];

    const filterColors = [];
    Object.keys(colorMap.default).forEach((code) => {
      const color = colorMap.default[code];
      if (color) {
        filterColors.push({
          code: Number(code),
          color,
          label: t(`layer.domain.currvalidationfield.${code}`),
        });
      }
    });
    return filterColors;
  }, [config, view]);

  const filtersArray = useMemo(() => {
    return filters[activeModule]?.currvalidationfield || [];
  }, [filters, activeModule]);

  const handleInputChange = useCallback(
    (e, code) => {
      const newFilters = JSON.parse(JSON.stringify(filters));
      if (!newFilters[activeModule]) return;
      const array = [...filtersArray];

      if (code === "all") {
        setShowFeaturesWithoutUpdates(e.target.checked);
        // if (array.length > 0) {
        //   cachedReportFilters.current = [...array];
        //   array.length = 0;
        // } else {
        //   array.push(...cachedReportFilters.current);
        // }
      } else if (code === "updates") {
        setShowSuggestUpdates(e.target.checked);
      } else {
        if (array.includes(code)) {
          array.splice(array.indexOf(code), 1);
        } else {
          array.push(Number(code));
        }
      }

      newFilters[activeModule]["currvalidationfield"] = array;
      setAndApplyFilters(newFilters);
    },
    [filters, activeModule, filtersArray]
  );

  const toggleFilter = useCallback(() => {
    setShow((prev) => !prev);
  }, []);

  if (colors.length === 0) return null;

  return (
    <div style={{ position: "relative", display: "flex" }}>
      {show && (
        <Tooltip
          blurred
          wrapperStyles={{
            width: "100%",
            height: "100%",
            position: "absolute",
            right: 0,
            top: 0,
          }}
          content={
            <StyledReportFilterContainer>
              {!editableLayer.layerConfig.isShownInReportManager && (
                <span
                  style={{
                    color: "var(--fontColor)",
                    textAlign: "center",
                    fontSize: "14px",
                    marginBottom: 2,
                  }}
                >
                  {t("screen.widget.Editor.manager.reports.filtersTitle")}
                </span>
              )}
              {colors.map(({ color, code, label }) => {
                const count = validationStatusMap[code] || 0;
                return (
                  <Checkbox
                    key={code}
                    label={`${label} (${count})`}
                    color={color}
                    borderRadius="4px"
                    onChange={(e) => handleInputChange(e, code)}
                    checked={filtersArray.includes(code)}
                  />
                );
              })}
              {/* {!editableLayer.layerConfig.isShownInReportManager ? (
                <Checkbox
                  label={t(
                    "screen.widget.Editor.manager.reports.filtersNoSuggestions"
                  )}
                  onChange={(e) => handleInputChange(e, "all")}
                  defaultChecked={showFeaturesWithoutUpdates}
                />
              ) : (
                <Checkbox
                  label={t(
                    "screen.widget.Editor.manager.reports.showSuggestUpdates"
                  )}
                  onChange={(e) => handleInputChange(e, "updates")}
                  defaultChecked={showSuggestUpdates}
                />
              )} */}
            </StyledReportFilterContainer>
          }
          visible
          blurred
          placement="bottom"
          padding={4}
          offset={16}
          showOnClick
        >
          <div
            style={{
              width: "auto",
              height: "100%",
              position: "absolute",
              right: 0,
              top: 0,
            }}
          ></div>
        </Tooltip>
      )}
      <FilterButton
        onClick={toggleFilter}
        style={{ zIndex: 1 }}
        isActive={filtersArray.length > 0}
      >
        <FilterIcon />
      </FilterButton>
    </div>
  );
};

export default ReportsFilter;
